import { NAME } from './constants';

export const REVOKE_PROFILE_DONE = `${NAME}/REVOKE_PROFILE_DONE`;
export const TOGGLE_PROFILE_STATUS = `${NAME}/TOGGLE_PROFILE_STATUS`;
export const PROFILE_ACTIVATED = `${NAME}/PROFILE_ACTIVATED`;
export const PROFILE_SUSPENDED = `${NAME}/PROFILE_SUSPENDED`;
export const APPROVE_PROFILE = `${NAME}/APPROVE_PROFILE`;
export const SUSPEND_PROFILE = `${NAME}/SUSPEND_PROFILE`;
export const KEEP_PROFILE_STATUS = `${NAME}/KEEP_PROFILE_STATUS`;
export const MAKE_PROFILE = `${NAME}/MAKE_PROFILE`;
export const MAKE_PROFILE_DONE = `${NAME}/MAKE_PROFILE_DONE`;
export const MAKING_PROFILE = `${NAME}/MAKING_PROFILE`;
export const MADE_PROFILE = `${NAME}/MADE_PROFILE`;
export const FETCH = `${NAME}/FETCH`;
export const FETCHED = `${NAME}/FETCHED`;
export const FETCHING = `${NAME}/FETCHING`;
export const CACHE = `${NAME}/CACHE`;
export const TOGGLE_MAKING_PROFILE = '{NAME}/TOGGLE_MAKING_PROFILE';
